import { INTEGRATION_VENDORS } from "@/const/vendors-constants"
import { TicketingConfigurationTab } from "@/pages/IntegrationsPage/components/organisms/TicketingConfigurationTab"
import { ConfigurationPageTemplate } from "@/pages/IntegrationsPage/components/templates/ConfigurationPageTemplate"
import { AsanaConnectTab } from "./AsanaConnectTab"

import type { TicketingConfigurationPageProps } from "./TicketingConfigurationPage.types"

export const TicketingConfigurationPage = ({
  vendor
}: TicketingConfigurationPageProps) => (
  <ConfigurationPageTemplate
    vendor={vendor}
    connect={
      vendor === INTEGRATION_VENDORS.asana ? <AsanaConnectTab /> : undefined
    }
    config={<TicketingConfigurationTab vendor={vendor} />}
    titleKey="integrations.configuration.ticketing.configurationTitle"
  />
)
